<template>
  <div class="exchange-coins-page">
    <!-- 顶部导航 -->
    <van-nav-bar
      :title="$t('column.exchange_coins')"
      left-arrow
      @click-left="goBack"
    >
      <template #right>
        <span class="nav-right-btn" @click="showRules">{{ $t('column.Rules') }}</span>
      </template>
    </van-nav-bar>

    <!-- 积分信息卡片 -->
    <van-col span="22" offset="1" class="points-card">
      <van-col span="24" class="available-points">
        <span class="points-value">{{ user.useable_ticket }}</span>
        <span class="points-label">{{ $t('exchange.available_points') }}</span>
      </van-col>
      <van-row class="points-row">
        <van-col span="12" class="points-item">
          <span class="points-number">{{ user.useable_ticket }}</span>
          <span class="points-text">{{ $t('exchange.total') }}</span>
        </van-col>
        <van-col span="12" class="points-item">
          <span class="points-number">{{ user.refund_ticket }}</span>
          <span class="points-text">
            {{ $t('exchange.unconfirmed') }}
            <van-icon name="question-o" size="14" color="#999" />
          </span>
        </van-col>
      </van-row>
    </van-col>

    <!-- 兑换选项 -->
    <van-col span="22" offset="1">
        <van-row class="exchange-options" gutter="20">
            <van-col span="12" v-for="(item,i) in exchangeOptions" :key="i">
              <van-col span="24" class="option-card" :class="{ 'option-active': selectedOption === i }" @click="selectOption(i)">
                  <van-col span="24" class="option-icon-row">
                  <img src="../assets/img/coin11.png" class="option-icon" />
                  <span class="option-value">{{ item.diamond }}</span>
                  </van-col>
                  <van-col span="24" class="option-icon-row">
                  <img src="../assets/img/coin9.png" class="option-icon" />
                  <span class="option-value2">{{ item.coin }}</span>
                  </van-col>
              </van-col>
            </van-col>
          
        </van-row>
      </van-col>
    

    <!-- 验证码输入 -->
    <van-col span="22" offset="1" class="verification-section">
      <van-col span="24" class="verification-title">{{ $t('column.verification_code') }}</van-col>
      <van-row class="verification-input-row" gutter="10">
        <van-col span="17">
          <van-field
            v-model="verificationCode"
            :placeholder="$t('placeholder.enter_verification_code')"
            class="verification-input"
          />
        </van-col>
        <van-col span="7">
          <van-button 
            class="send-code-btn" 
            @click="refreshCaptchaCode"
          >
            {{ captchaCode }}
            <van-icon name="replay" :class="{ 'rotating': isRefreshing }" />
          </van-button>
        </van-col>
      </van-row>
    </van-col>

    <!-- 底部兑换按钮 -->
    <van-col span="22" offset="1" class="exchange-btn-wrapper">
      <van-button 
        color="#F45782" 
        block 
        round 
        class="exchange-btn"
        @click="handleExchange"
      >
        {{ $t('column.exchange_coins') }}
      </van-button>
    </van-col>

    <!-- 规则弹窗 -->
    <van-popup v-model="rulesShow" round :style="{ height: '60%', width: '90%' }">
      <van-col span="24" class="rules-popup">
        <van-col span="22" offset="1" class="rules-title">{{ articleList.title }}</van-col>
        <van-col span="22" offset="1" class="rules-content" v-html="articleList.content"> 
        </van-col>
      </van-col>
    </van-popup>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast, Dialog } from 'vant'

export default {
  name: 'ExchangeCoins',
  data() {
    return {
      user: {
        useable_ticket: 0,
        ticket: 0,
        refund_ticket: 0,
        diamonds: 0
      },
      selectedOption: 0,
      exchangeOptions: [],
      exchangeRuleIds: [],
      verificationCode: '',
      captchaCode: '',
      rulesShow: false,
      articleList: [],
      isRefreshing: false
    }
  },
  created() {
    this.loadPointsData()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    showRules() {
      this.rulesShow = true
    },
    loadPointsData() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=wallet&act=user_exchange_list', {
        params: { uid: uid, token: token }
      }).then(res => {
        if (res.data.status === 1) {
          const data = res.data.data
          this.user = data.user
          this.captchaCode = data.captcha_code
          this.articleList = data.article_list || []
          // 将规则列表转换为兑换选项
          if (data.list && data.list.length > 0) {
            this.exchangeOptions = data.list.map(item => ({
              diamond: item.diamonds,
              coin: item.ticket
            }))
            this.exchangeRuleIds = data.list.map(item => item.id)
          }
        } else {
          Toast(res.data.error)
        }
      }).catch(err => {
        Toast(this.$t('exchange.load_failed'))
      })
    },
    selectOption(index) {
      this.selectedOption = index
    },
    refreshCaptchaCode() {
      // 如果正在刷新中，则不重复触发
      if (this.isRefreshing) return
      
      this.isRefreshing = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=wallet&act=refresh_captcha_code', {
        params: { uid: uid, token: token }
      }).then(res => {
        if (res.data.status === 1) {
          this.captchaCode = res.data.data.captcha_code
        } else {
          Toast(res.data.error)
        }
      }).catch(err => {
        Toast(err.message)
      }).finally(() => {
        // 请求完成后停止旋转
        setTimeout(() => {
          this.isRefreshing = false
        }, 500)
      })
    },
    handleExchange() {
      if (!this.verificationCode) {
        Toast(this.$t('exchange.please_enter_code'))
        return
      }
      if (this.exchangeRuleIds.length === 0) {
        Toast(this.$t('exchange.no_exchange_rules'))
        return
      }
      
      // 显示确认框
      Dialog.confirm({
        title: this.$t('exchange.confirm_exchange'),
        message: this.$t('exchange.confirm_exchange_message')
      }).then(() => {
        // 用户点击确认
        this.doExchange()
      }).catch(() => {
        // 用户点击取消
      })
    },
    doExchange() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const ruleId = this.exchangeRuleIds[this.selectedOption]
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=wallet&act=do_exchange_coin', {
        params: { uid: uid, token: token, exchange_rule_id: ruleId, captcha_code: this.verificationCode }
      }).then(res => {
        if (res.data.status === 1) {
          Toast(res.data.error)
          // 刷新余额数据
          this.loadPointsData()
          this.verificationCode = ''
        } else {
          Toast(res.data.error)
          // 验证码错误或过期时刷新验证码
          if (res.data.error === this.$t('exchange.code_expired') || res.data.error === this.$t('exchange.code_incorrect')) {
            this.refreshCaptchaCode()
          }
        }
      }).catch(err => {
        Toast(this.$t('exchange.exchange_failed'))
      })
    }
  }
}
</script>

<style scoped>
/* 刷新图标旋转动画 */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotate 1s linear infinite;
  display: inline-block;
}

.send-code-btn .van-icon {
  margin-left: 4px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/exchange_coin.vue